module.exports = __webpack_public_path__ + "img/icon-lang.3d39ee5.svg";